module.exports = __webpack_public_path__ + "static/img/gh_7de3271144d8_258.37707f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gh_7de3271144d8_258.jpg
// module id = a6hL
// module chunks = 1